export * from './InfoBanner';
export { default } from './InfoBanner';
